import type {
    Category,
    TransformedSubItemForMatrices,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/matrices/ui/___shared___/components/custom-category-selector/types.ts';
import { castArray, compact, get, has, isNil } from 'lodash';

const nextSelectedKeys = (
    key: keyof Pick<TransformedSubItemForMatrices, 'type' | 'category'>,
    items: Category[],
    allowedSubItems: TransformedSubItemForMatrices[],
    nextCheckedSubItemValues: Set<string>,
): string[] =>
    items
        .map((item) => item.value)
        .filter((itemValue) => {
            const matchingSubItems = allowedSubItems.filter((subItem) => subItem[key] === itemValue);

            if (matchingSubItems.length === 0) return false;

            return matchingSubItems.every((subItem) => nextCheckedSubItemValues.has(String(subItem.value)));
        });

export const getNextSelectedTypes = (
    levelOneItems: Category[],
    allowedSubItems: TransformedSubItemForMatrices[],
    nextCheckedSubItemValues: Set<string>,
) => nextSelectedKeys('type', levelOneItems, allowedSubItems, nextCheckedSubItemValues);

export const getNextSelectedCategories = (
    levelTwoItems: Category[],
    allowedSubItems: TransformedSubItemForMatrices[],
    nextCheckedSubItemValues: Set<string>,
) => nextSelectedKeys('category', levelTwoItems, allowedSubItems, nextCheckedSubItemValues);

type SelectedSubItemValue =
    | string
    | number
    | {
          value?: string | number | null;
      }
    | null
    | undefined;

const getSelectedValue = (item: SelectedSubItemValue): string | null => {
    const value = has(item, 'value') ? get(item, 'value') : item;
    return isNil(value) || value === '' ? null : String(value);
};

export const normalizeSelectedSubItems = (value: SelectedSubItemValue | SelectedSubItemValue[]): string[] =>
    compact(castArray(value).map(getSelectedValue));
